module.exports = __webpack_public_path__ + "assets/d333503d3c20a50d3ed475e76e3884a1.png";